export const ANSWER_COLORS = ["#E21B3C", "#1368CE", "#D89E00", "#26890C", "#864CBF", "#E65100"];
export const ANSWER_BORDERS = ["#800F21", "#0A366D", "#735400", "#124205", "#432363", "#7C2B00"];

const PATHS = [
  "M12 3 L22 20 L2 20 Z",
  "M12 2 L22 12 L12 22 L2 12 Z",
  null,
  "M4 4 H20 V20 H4 Z",
  "M12 2 L14.9 8.6 L22 9.3 L16.6 14 L18.2 21 L12 17.3 L5.8 21 L7.4 14 L2 9.3 L9.1 8.6 Z",
  "M7 3 H17 L22 12 L17 21 H7 L2 12 Z",
];

export const AnswerShape = ({ i, size = "1em", color = "#fff" }) => (
  <svg viewBox="0 0 24 24" style={{ width: size, height: size, flexShrink: 0 }} aria-hidden="true">
    {i === 2 ? <circle cx="12" cy="12" r="10" fill={color} /> : <path d={PATHS[i]} fill={color} />}
  </svg>
);
